import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import useAnchoredModalStyle from '../utils/useAnchoredModalStyle';

function ModalConfirmacion({
  mensaje, onConfirmar, onCancelar, textoConfirmar = 'Confirmar', textoAlerta = null, anchorRect = null,
  pedirPassword = false, errorExterno = null,
}) {
  // Mismo posicionamiento que ModalExportarPDF: centrado horizontal, borde
  // superior a la altura del botón disparador (anchorRect), clampeado al
  // viewport. Sin anchorRect (o en ≤680px) el CSS del overlay toma el control.
  const cardStyle = useAnchoredModalStyle(anchorRect, { maxWidth: 420, minVisible: 200 });
  const [password, setPassword] = useState('');

  const confirmarDisabled = pedirPassword && password.trim() === '';
  const handleConfirmar = () => {
    if (confirmarDisabled) return;
    pedirPassword ? onConfirmar(password) : onConfirmar();
  };

  // Portal a <body>: mismo motivo que ModalExportarPDF — un transform/filter en
  // un ancestro rompería el position:fixed calculado contra el viewport.
  return createPortal(
    <div
      className="modal-overlay"
      onClick={(e) => e.target === e.currentTarget && onCancelar()}
    >
      <div className="modal-card modal-card-sm" style={cardStyle}>
        <div className="modal-header">
          <h3>Confirmar acción</h3>
          <button className="modal-btn-cerrar" onClick={onCancelar}>✕</button>
        </div>
        <div className="modal-body">
          <p className="confirm-mensaje">{mensaje}</p>
          {textoAlerta && (
            <p className="confirm-alerta">{textoAlerta}</p>
          )}
          {pedirPassword && (
            <div className="kinesio-campo-grupo" style={{ marginTop: 10 }}>
              <label className="kinesio-label">Contraseña de tu cuenta</label>
              <input
                type="password"
                className="ficha-input"
                autoComplete="new-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoFocus
              />
              {errorExterno && <p className="confirm-alerta" style={{ marginTop: 6 }}>{errorExterno}</p>}
            </div>
          )}
          <div className="modal-acciones">
            <button type="button" className="modal-btn-cancelar" onClick={onCancelar}>Cancelar</button>
            <button type="button" className="modal-btn-peligro" onClick={handleConfirmar} disabled={confirmarDisabled}>{textoConfirmar}</button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default ModalConfirmacion;
